import actionTypes from './action-types';

export const onItemListSelection = ({
  gameNumber,
  packNo,
  portionNumber,
  orderId = undefined,
  retailerId = undefined,
  retailerNumber = undefined,
}) => {
  return {
    type: actionTypes.ON_ITEM_LIST_SELECTION,
    selection: {
      gameNumber,
      packNo: packNo ? packNo.split(' ')[0] : undefined,
      portionNumber,
      orderId,
      retailerId,
      retailerNumber,
    },
  };
};

export const resetDetailsDialogData = () => {
  return {
    type: actionTypes.RESET_DETAILS_DIALOG_DATA,
  };
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/manage-inventory.actions.js